// The step bar's data (encounter-step-bar.tsx): which steps it lists before Start, and which step Next goes to. Pure.
import type { Questionnaire } from '@scripsteam/scrips-signal-ds';
import { stepLabel, type PaStepKey } from './encounter-steps';
import type { StepTitleOverrides } from './cps-layout';
import { visibleSteps } from './questionnaire-groups';
import { sectionsFor } from './soap-ribbon';

/**
 * The steps the encounter will show once started, for the step bar ahead of Start. The same answer the started view
 * gives: the resolved nav filtered by the template (`visibleSteps`, fail-open), labelled with the template's own step
 * titles; frame v2 groups them into its S · O · A&P (or P) sections, as its ribbon does.
 */
export function upcomingEncounterSteps(
  nav: readonly PaStepKey[],
  questionnaire: Questionnaire | undefined,
  currentStep: PaStepKey,
  stepTitles: StepTitleOverrides | undefined,
  frameV2: boolean,
): { id: string; label: string }[] {
  const steps = visibleSteps(nav, questionnaire, currentStep);
  if (frameV2) return sectionsFor(steps).map((section) => ({ id: section.id, label: section.title }));
  return steps.map((step) => ({ id: step, label: stepLabel(step, stepTitles) }));
}

/** The step after `current` in `steps`, or undefined on the last step (or when `current` is not in the list). */
export function nextStepOf<T extends string>(steps: readonly T[], current: T): T | undefined {
  const i = steps.indexOf(current);
  return i >= 0 ? steps[i + 1] : undefined;
}
